export default __webpack_public_path__ + "static/media/prestations.09f0d99a.svg";